import { TOAST_DEFAULT_OPTIONS } from '@/constants/toast';
import useOnMount from '@/hooks/useOnMount';
import { useSetIntercomIsVisible } from '@/queries/layout.queries';
import { useToast } from '@cmpsr/components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Questionnaire from '../questionnaire/components/questionnaire/questionnaire';
import useQuizletController from './quizlet.controller';
import { ROUTE_QUIZLET_RESULTS } from '@/constants/routes';

export function QuizletPage() {
  const toast = useToast();
  const navigate = useNavigate();
  const setIntercomIsVisible = useSetIntercomIsVisible();
  const { status, error, userQuestionnaire, decisionTreeCallback, backOnFirstSurveyItem, onItemViewed } =
    useQuizletController();

  // Hide intercom when the component mounts
  useOnMount(() => {
    setIntercomIsVisible.mutate(false);
    return () => {
      setIntercomIsVisible.mutate(true);
    };
  });

  useEffect(() => {
    if (error) {
      toast({
        ...TOAST_DEFAULT_OPTIONS,
        title: 'Error',
        description: 'Error connecting to the Catch server.',
        status: 'error',
      });
    }
  }, [error, toast]);

  // Navigate to the results page if the survey is completed
  useEffect(() => {
    if (status === 'completed' && userQuestionnaire) {
      // Navigate to the quizlet results page
      navigate(ROUTE_QUIZLET_RESULTS);
      return;
    }
  }, [status, userQuestionnaire, navigate]);

  if (!userQuestionnaire) {
    return null;
  }

  return (
    <Questionnaire
      userQuestionnaire={userQuestionnaire}
      decisionTreeCallback={decisionTreeCallback}
      backOnFirstSurveyItem={backOnFirstSurveyItem}
      onItemViewed={onItemViewed}
    />
  );
}
